// data-layer.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  pushEvent(event: any) {
    (<any>window).dataLayer.push(event);
  }
}
